export default __webpack_public_path__ + "static/media/Igtv-Icon.4d912af2.png";